







































import UnitModel from '@/_models/UnitModel'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class TrackingData extends Vue {
  public trackingBlocks = [
    {
      title: this.$t('label.location'),
      description: [
        this.$t('content.first_ex_location'),
        this.$t('content.second_ex_location'),
      ],
      type: 'location',
    },
    {
      title: this.$t('label.stat'),
      description: [
        this.$t('content.first_ex_stats'),
        this.$t('content.second_ex_stats'),
      ],
      type: 'stat',
    },
  ]

  get selected(): UnitModel {
    return this.$store.state.units.item
  }

  public deleteTrackingData(type: string) {
    this.$buefy.dialog.confirm({
      title: this.$t('delete') as string,
      message: this.$t('messages.are_you_sure_want_to_delete') as string,
      confirmText: this.$t('delete') as string,
      cancelText: this.$t('button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        this.$store
          .dispatch('units/deleteAllData', {
            collection: type,
            unit: {
              db_name: this.selected.db_name
            },
          })
          .then(() => {
            this.$buefy.toast.open(this.$t('messages.delete_success') as string)
          })
      },
    })
  }
}
